function delay(time: number, cb: () => void = () => {}) {
  return new Promise<void>((resolve, reject) => {
    setTimeout(() => {
      try {
        cb()
        resolve(undefined)
      } catch (e) {
        reject(e as Error)
      }
    }, time)
  })
}

export default delay
